import { IntroductionVideoDialog } from "./introduction-video-dialog.js";
import { IntroductionVideoFloatingButton } from "./introduction-video-floating-button.js";

interface IntroductionVideoProps {
  open: boolean;
  onDismiss: (action: "dismissed" | "doNotShowAgain") => void;
  onRequestOpen: () => void;
  showFloatingButton: boolean;
  floatingButtonStackIndex?: number;
  videoId: string;
}

export const IntroductionVideo = ({
  open,
  onDismiss,
  onRequestOpen,
  showFloatingButton,
  floatingButtonStackIndex = 0,
  videoId,
}: IntroductionVideoProps) => (
  <>
    <IntroductionVideoDialog
      onDismiss={onDismiss}
      open={open}
      videoId={videoId}
    />
    {Boolean(showFloatingButton) && (
      <IntroductionVideoFloatingButton
        onClick={onRequestOpen}
        stackIndex={floatingButtonStackIndex}
      />
    )}
  </>
);
